import { DEAL_TYPE_KEYS } from "@frontend/common";

import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";

import DealTermsMergeGroupTable from "./components/DealTermsMergeGroupTable/DealTermsMergeGroupTable";
import DealTermsVentureFormationGroupTable from "./components/DealTermsVentureFormationGroupTable/DealTermsVentureFormationGroupTable";
import { DEAL_TERMS_LAYOUT } from "./constants/dealTermsLayout";

const GROUP_TABLE_INDEX = 2;

// NOTE: V2(LA&SC)로 이관되지 않은 M&A·순수 Venture Formation(VF && !LA) 만 V1 Deal Terms 로 렌더한다.
// 그 외 카테고리(License Agreement·Cross License·VF+LA 등)는 DealLaScDealTermsGroupTable(V2)가 담당한다.
const DealsDealTermsTableCreatorContainer = () => {
  const mergeLayout = DEAL_TERMS_LAYOUT["M&A"];
  const ventureFormationLayout = DEAL_TERMS_LAYOUT["Venture Formation"];

  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  if (isMergeAndAcquisition)
    return (
      <DealTermsMergeGroupTable
        key={`group-table-${String(GROUP_TABLE_INDEX)}`}
        groupTableKey={mergeLayout.groupTableKey}
        tableList={mergeLayout.tableList}
        groupTableIndex={GROUP_TABLE_INDEX}
      />
    );

  if (
    currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation) &&
    !currentDealTypeList.includes(DEAL_TYPE_KEYS.licenseAgreement)
  ) {
    return (
      <DealTermsVentureFormationGroupTable
        key={`group-table-${String(GROUP_TABLE_INDEX)}`}
        groupTableKey={ventureFormationLayout.groupTableKey}
        tableList={ventureFormationLayout.tableList}
        groupTableIndex={GROUP_TABLE_INDEX}
      />
    );
  }

  return null;
};

export default DealsDealTermsTableCreatorContainer;
